import React from 'react';
import IconBase from './IconBase';
const YouTubeIcon = props => React.createElement(IconBase, props, React.createElement("g", {
  id: "Mask"
}, React.createElement("path", {
  d: "M62.6,16.534c-0.776-3.371-3.533-5.857-6.852-6.228c-7.859-0.877-15.814-0.882-23.732-0.877 c-7.919-0.005-15.876,0-23.735,0.877c-3.317,0.371-6.072,2.858-6.848,6.228c-1.104,4.8-1.117,10.04-1.117,14.982 s0,10.181,1.104,14.981c0.775,3.37,3.53,5.857,6.849,6.228c7.859,0.878,15.814,0.883,23.734,0.878 c7.921,0.005,15.874,0,23.732-0.878c3.317-0.371,6.075-2.858,6.85-6.228c1.105-4.8,1.109-10.039,1.109-14.981 C63.695,26.574,63.705,21.335,62.6,16.534z M23.827,41.353c0-7.011,0-13.948,0-20.96c6.717,3.505,13.389,6.986,20.149,10.512 C37.238,34.401,30.562,37.861,23.827,41.353z"
})));
YouTubeIcon.defaultProps = {
  title: 'YouTubeIcon'
};
export default YouTubeIcon;
//# sourceMappingURL=YouTubeIcon.js.map